import React from "react";
import {IProduct} from 'data/interfaces/products';
import styles from "./AirlineImageSquare.module.scss";

import FlightIcon from '@material-ui/icons/Flight';
import GenericImageSquare from "../genericImageSquare/GenericImageSquare";

export interface IAirlineImageSquare {
  product: IProduct;
  className?: string;
  iconContainerClassName?: string;
  children?: any;
}

export const flightCompanyToLogoUrl = flightCompany => `/img/airlines/${flightCompany.icao}.png`;

const AirlineImageSquare = (props: IAirlineImageSquare) => (
  <GenericImageSquare
    className={`${styles.AirlineImageSquare} ${props.className}`.trim()}
    iconContainerClassName={`${props.iconContainerClassName} ${styles.iconContainerClassName}`}
    icon={FlightIcon}
    label="טיסה"
    logoSrc={[
      flightCompanyToLogoUrl(props.product.ticketDetails.originFlightCompany),
      props.product.ticketDetails.destinationFlightCompany && flightCompanyToLogoUrl(props.product.ticketDetails.destinationFlightCompany),
    ]}
    logoTitle={props.product.ticketDetails.originFlightCompany.name}
    children={props.children}
  />
);

AirlineImageSquare.defaultProps = {
  className: '',
};

export default AirlineImageSquare;
